import Repository from '../../repositories/RepositoryFactory';
const ccmBillingRepository = Repository.get('ccmBilling');

export default {
  namespaced: true,
  state: {
    ccmBillingByPatientId: [],
    ccmBillingByCCMRecordId: [],
    ccmBilling: null,
  },
  mutations: {
    STORE_CCM_BILLING_BY_PATIENT_ID (state, payload) {
      state.ccmBillingByPatientId = payload;
    },
    STORE_CCM_BILLING_BY_CCM_RECORD_ID (state, payload) {
      state.ccmBillingByCCMRecordId = payload;
    },
    STORE_CCM_BILLING (state, payload) {
      state.ccmBilling = payload;
    },
  },
  actions: {
    async getCCMBillingByPatientId ({ commit }, patientId) {
      const response = await ccmBillingRepository.getCCMBillingByPatientId(
        patientId,
      );
      commit('STORE_CCM_BILLING_BY_PATIENT_ID', response.data);
    },

    async getCCMBillingByCCMRecordId ({ commit }, ccmRecordId) {
      const response =
        await ccmBillingRepository.getCCMBillingByCCMRecordId(ccmRecordId);

      var conditions = [];
      if (response.data) {
        response.data.forEach((condition) => {
          if (condition.isPrimary) {
            conditions.unshift(condition);
          } else {
            conditions.push(condition);
          }
        });
      }

      commit('STORE_CCM_BILLING_BY_CCM_RECORD_ID', conditions);
    },

    async getCCMBilling ({ commit }, id) {
      const response = await ccmBillingRepository.getCCMBilling(id);
      commit('STORE_CCM_BILLING', response.data);
    },
  },
};
